import moment, { Moment } from "moment";

export const useDisabledFromTomorrow = (current: Moment): boolean => {
  return current > moment().endOf("day");
};

export const useDisabledBackDate = (current: Moment): boolean => {
  return current < moment().subtract(1, "days").endOf("day");
};

export const useDisabledSameMonth = (
  current: Moment,
  baseDate: Moment | null
): boolean => {
  if (!baseDate) return false;

  const startOfMonth = moment(baseDate).startOf("month");
  const endOfMonth = moment(baseDate).endOf("month");

  return (
    current.isBefore(startOfMonth, "day") || current.isAfter(endOfMonth, "day")
  );
};

export const useMaxOneYear = (
  current: Moment,
  maxDate: Moment | null
): boolean => {
  if (!maxDate) return false;
  return current.isAfter(maxDate);
};

export const useMinByDate = (
  current: Moment,
  minDate: Moment | null
): boolean => {
  if (!minDate) return false;
  return current.isBefore(minDate, "day");
};

export const isDifferentYear = (
  current: Moment,
  originalDate: Moment | string | null,
  restrict: boolean
): boolean => {
  if (!restrict || !originalDate) {
    return false;
  }

  return current.year() !== moment(originalDate).year();
};
